import type { StatusOption } from './types';

export const API_URL: string = process.env.REACT_APP_API_URL || 'https://api.getnovala.com';

export const FONT = 'Inter, -apple-system, sans-serif';

export const STATUS_OPTIONS: ReadonlyArray<StatusOption> = [
  { key: 'in_crew', label: 'In crew' },
  { key: 'desks', label: 'Desks' },
  { key: 'skipped', label: 'Skipped' },
  { key: 'not_ready', label: 'Not ready' },
];

export const GRID_COLS = '30px 26px 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 40px';

// Left offset that lines sub-panel up under the employee name column:
// 20 (row padding) + 30 (checkbox) + 16 (gap) + 26 (chevron) + 16 (gap)
export const SUB_PANEL_INDENT = 108;